/**
 * @typedef {import('vue').ComponentOptions<Vue>} VueComponent
 */

/** @type {VueComponent} */

import Vue from 'vue';

export default {
    props: {
        section: {
            type: Object,
        },
        isDarkVariant: {
            type: Boolean,
            required: false,
        },
        isSpecialMicrosite: {
            type: Boolean,
            required: false,
        },
    },

    data() {
        return {
            selectedModel: null,
            timeout: null,
        };
    },

    mounted() {
        this.selectedModel = this.$parent.initialModel;
        if (!this.isDarkVariant) return;
        window.addEventListener('resize', this.setScrollbarLeftSizeOffset);
        this.timeout = setTimeout(() => {
            this.setScrollbarLeftSizeOffset();
        }, 400);
    },

    beforeDestroy() {
        clearTimeout(this.timeout);
        window.removeEventListener('resize', this.setScrollbarLeftSizeOffset);
    },

    components: {
        'model-slider-carousel': () => import('./async-slider-carousel'),
        'model-features-accordion': () => import('./async-features-accordion'),
    },

    methods: {
        setScrollbarLeftSizeOffset() {
            if (!this.isDarkVariant) return;

            const element = document.querySelector(
                '.slider-section-features__content-container',
            );
            const scrollBar = document.querySelector('.swiper-scrollbar');
            if (!element || !scrollBar) return;

            const leftOffset = element.getBoundingClientRect().left - 30; // 30px is the padding of the container
            scrollBar.style.left = `${leftOffset}px`;
        },
    },
};
